/* eslint-disable no-unsafe-optional-chaining */
import { inject as controller } from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import DayDetailControllerBaseController from 'lumen/controllers/day-detail-controller-base';

export default class MarketMarketratesDetailController extends DayDetailControllerBaseController {
  @service router;

  @controller('market.marketrates') rates;

  get activeCompset() {
    if (!this.hotel?.loading) {
      return (this.hotel?.compsets.filter((compset) => compset.isPrimary))[0];
    }
    return null;
  }

  get ratesParams() {
    const { room } = this;

    return {
      los: this.rates?.los,
      mealtype: this.rates?.mealPlan === 0 ? null : this.rates?.mealPlan,
      persons: this.rates?.maxPersons,
      membershiptype: this.rates?.membershipType,
      room,
      ota: this.rates?.otaId,
      rateParam: this.rates?.rateParam,
      brand: this.rates?.brands,
      management_type: this.rates?.managementTypes,
      platform: this.rates?.platform,
    };
  }

  /**
   * Return the room for the selected roomType and hotel, or if it can't find it the roomtype string
   */
  get room() {
    const roomtypeSelections = (
      this.hotel?.roomtype?.roomtypeSelections ?? []
    ).filter(
      (roomtypeSelection) => roomtypeSelection.id === this.rates?.roomType,
    );
    let room = null;
    if (roomtypeSelections.length) {
      room = roomtypeSelections[0].id;
    } else {
      room = this.rates?.roomType;
    }
    return room === 'all' || room.id === 'all' ? null : room;
  }

  @action
  redirect() {
    this.router.legacyTransitionTo('market.marketrates');
  }
}
